import { useQuery } from '@tanstack/react-query';
import { API_URL } from '../../../config';
import { toApiError } from '../../../lib/api-error';

export interface TaskRepo {
  id: string;
  repoFullName: string;
  propertyId: string;
  propertyName: string;
}

interface TaskReposResponse {
  ok: boolean;
  data: TaskRepo[];
}

export function useTaskRepos() {
  return useQuery({
    queryKey: ['task-repos'],
    queryFn: async (): Promise<TaskReposResponse> => {
      const res = await fetch(`${API_URL}/tasks/repos`, {
        credentials: 'include',
      });
      if (!res.ok) throw await toApiError(res, 'Failed to fetch task repos');
      return res.json();
    },
    staleTime: 5 * 60_000,
  });
}
